import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../config/firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth
import { collection, getDocs } from "firebase/firestore";
import "./home.css";
import slide1 from "../assets/ho1.png";
import slide2 from "../assets/ho2.png";
import slide3 from "../assets/ho3.png";

const HomePage = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading

  const auth = getAuth(); // Initialize Firebase Auth
  const images = [slide1, slide2, slide3];

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true); // User is logged in
      } else {
        setIsAuthenticated(false); // User is not logged in
        navigate("/", { replace: true });
      }
    });
    return () => unsubscribe(); // Cleanup listener
  }, [navigate]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersSnapshot = await getDocs(collection(db, "users"));
        if (!usersSnapshot.empty) {
          const firstUser = usersSnapshot.docs[0].id;
          setUserId(firstUser);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleLogoutClick = () => setShowLogoutModal(true);

  const confirmLogout = () => {
    setShowLogoutModal(false);
    auth.signOut().then(() => {
      sessionStorage.clear();
      localStorage.clear();
      setIsAuthenticated(false);
      navigate("/", { replace: true });
    }).catch((error) => {
      console.error("Logout failed:", error);
    });
  };

  const cancelLogout = () => setShowLogoutModal(false);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Or a spinner
  }

  // Redirect if not authenticated
  if (!isAuthenticated) return null;

  return (
    <div className="home-container">
      <nav className="navbar">
        <ul>
          <li>Home</li>
          <li onClick={() => navigate("/categories")}>Categories</li>
          <li
            onClick={() => userId && navigate(`/users/${userId}/orders`)}
            className={userId ? "" : "disabled"}
          >
            Orders
          </li>
          <li onClick={() => navigate("/users")}>Users</li>
          <li onClick={handleLogoutClick} className="logout">
            Logout
          </li>
        </ul>
      </nav>
      <div className="content">
        <h1>Welcome to the Shree Kannan Store Dashboard</h1>
        <div className="para">
          <p>Manage your store efficiently.</p>
        </div>
        <div className="slider-container">
          <img src={images[currentSlide]} alt="Slide" className="slider-image" />
        </div>
      </div>
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div className="modal-buttons">
              <button onClick={confirmLogout} className="confirm-btn">
                Yes
              </button>
              <button onClick={cancelLogout} className="cancel-btn">
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;